module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../../node_modules/happypack/loader.js?id=jsx!./ReceiveListView.js"));
	}, "ReceiveListView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=ReceiveListView!./src/pages/Shop/Member/Personal/GiftWarehouse/ReceiveList/ReceiveListView.js
// module id = 998
// module chunks = 438